// Generated by scripts/compose-modules.mjs for the plugins in lancerlogin.modules.json. Do not commit; restore with npm run compose:modules -- --restore.
import type { DashboardModuleContribution } from "../module-contributions.ts";
import module_hour_tracking from "../../../../.provision/module-plugins/hour-tracking/src/dashboard.tsx";
import module_carpool from "../../../../.provision/module-plugins/carpool/src/dashboard.tsx";
import module_visits from "../../../../.provision/module-plugins/visits/src/dashboard.tsx";

export const externalDashboardModules: readonly DashboardModuleContribution[] = [module_hour_tracking, module_carpool, module_visits];
